export class CreationFilterModel {
    public curatedOnly: boolean;
    public filterKey: string;
    public pageNumber: number;
    public perPage: number;
}



// WEBPACK FOOTER //
// ./src/models/creation/creation.filter.model.ts